import { render, staticRenderFns } from "./AddPeriodical.vue?vue&type=template&id=42c714c3&scoped=true&"
import script from "./AddPeriodical.vue?vue&type=script&lang=js&"
export * from "./AddPeriodical.vue?vue&type=script&lang=js&"
import style0 from "./AddPeriodical.vue?vue&type=style&index=0&id=42c714c3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c714c3",
  null
  
)

export default component.exports